var pe = Object.defineProperty, _e = Object.defineProperties;
var he = Object.getOwnPropertyDescriptors;
var j = Object.getOwnPropertySymbols;
var ge = Object.prototype.hasOwnProperty, ke = Object.prototype.propertyIsEnumerable;
var N = (m, n, d) => n in m ? pe(m, n, { enumerable: !0, configurable: !0, writable: !0, value: d }) : m[n] = d, z = (m, n) => {
  for (var d in n || (n = {}))
    ge.call(n, d) && N(m, d, n[d]);
  if (j)
    for (var d of j(n))
      ke.call(n, d) && N(m, d, n[d]);
  return m;
}, Y = (m, n) => _e(m, he(n));
var G = (m, n, d) => new Promise((U, h) => {
  var p = (k) => {
    try {
      x(d.next(k));
    } catch (b) {
      h(b);
    }
  }, A = (k) => {
    try {
      x(d.throw(k));
    } catch (b) {
      h(b);
    }
  }, x = (k) => k.done ? U(k.value) : Promise.resolve(k.value).then(p, A);
  x((d = d.apply(m, n)).next());
});
import { s as Ce, m as v, aq as we, u as Se, q as be, o as xe, b as qe, c as t, e as s, g as o, j as q, f as a, i as C, t as l, k as u, h as f, F as H, p as J, w as T, ak as Te, l as $, av as K } from "./define-element-XpjsV6s1.js";
import { u as Ue } from "./use-user-CwEHAZOt.js";
import { u as Be } from "./use-cart-D8NOb7eE.js";
import { u as Oe } from "./use-addresses-Wp77HwbF.js";
import { u as Ve } from "./use-config-1FCHS5th.js";
import { u as $e } from "./use-wishlist-DGdQdUnB.js";
import { i as S } from "./utils-CMsllPx8.js";
import { B as X } from "./Button-D5lKR5Sd.js";
import { Q as Z } from "./QuantitySelect-ZqpfOW1n.js";
import { f as c } from "./format-currency-D_QngrXg.js";
import { L as y } from "./Loader-CeIJU_1y.js";
import { P as Ae } from "./PromoCode-q3MmxwYM.js";
/* empty css                                                              */
import { _ as De } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { A as Me } from "./Accordion-ETC-82Nb.js";
const Qe = {
  class: "offset-cart",
  ref: "container"
}, Ie = { class: "offset-cart-wrapper" }, Re = { class: "offset-header" }, Ee = {
  key: 0,
  class: "offset-cart-max-quantity-warning",
  role: "alert"
}, Fe = { key: 1 }, Le = {
  key: 2,
  class: "offset-cart-container"
}, Pe = { class: "offset-items-wrapper" }, We = {
  key: 0,
  class: "offset-order-info cart-expires-message"
}, je = { class: "offset-items" }, Ne = {
  key: 0,
  class: "item-image"
}, ze = ["src", "alt"], Ye = { class: "item-name" }, Ge = { key: 0 }, He = { class: "offset-items-quantity" }, Je = {
  key: 1,
  class: "offset-items-quantity-readonly"
}, Ke = { class: "item-total" }, Xe = { key: 0 }, Ze = { key: 1 }, et = {
  key: 1,
  class: "offset-empty-cart"
}, tt = {
  key: 0,
  class: "offset-cart-adding-item"
}, st = { class: "offset-items" }, ot = { class: "item-name" }, at = { class: "offset-items-quantity" }, it = {
  key: 1,
  class: "offset-items-quantity-readonly"
}, nt = { class: "item-total" }, rt = { class: "offset-order-summary-subtotal" }, lt = {
  key: 1,
  class: "offset-order-summary",
  "aria-live": "polite"
}, dt = {
  key: 1,
  class: "offset-order-info"
}, ut = { class: "offset-order-summary-subtotal" }, ft = { key: 0 }, vt = { key: 1 }, mt = {
  key: 2,
  class: "offset-order-summary-discount"
}, ct = { key: 0 }, yt = { key: 1 }, pt = {
  key: 3,
  class: "offset-order-summary-shipping"
}, _t = { key: 0 }, ht = { key: 1 }, gt = { key: 2 }, kt = { key: 3 }, Ct = {
  key: 4,
  class: "offset-order-summary-shipping"
}, wt = { key: 0 }, St = { key: 1 }, bt = {
  key: 5,
  class: "offset-order-summary-insurance"
}, xt = { key: 0 }, qt = { key: 1 }, Tt = {
  key: 6,
  class: "offset-order-summary-redemption-value"
}, Ut = { key: 0 }, Bt = { key: 1 }, Ot = {
  key: 7,
  class: "offset-order-summary-redemption-value"
}, Vt = { key: 0 }, $t = { key: 1 }, At = {
  key: 8,
  class: "offset-order-summary-redemption-value"
}, Dt = { key: 0 }, Mt = { key: 1 }, Qt = { class: "offset-order-summary-tax" }, It = { key: 0 }, Rt = { key: 1 }, Et = { class: "offset-order-summary-total" }, Ft = { key: 0 }, Lt = { key: 1 }, Pt = {
  key: 9,
  class: "offset-order-summary-actions"
};
var ee, te;
const Wt = {
  __name: "Cart",
  props: {
    showPromoCode: {
      type: Boolean,
      default: !0
    },
    inheritStyle: {
      type: String,
      default: "all"
    },
    // Left unset by default so the type-aware getCheckoutUrl() fallback (see
    // checkoutUrlResolved below) applies — pass an explicit checkout-url
    // attribute to override it.
    checkoutUrl: {
      type: String,
      default: ""
    },
    shopUrl: {
      type: String,
      default: (te = (ee = window.OFFSET) == null ? void 0 : ee.shopUrl) != null ? te : "/"
    },
    readOnly: {
      type: Boolean,
      default: !1
    },
    hideActions: {
      type: Boolean,
      default: !1
    },
    isOffering: {
      type: Boolean,
      default: !1
    },
    shippingExempt: {
      type: Boolean,
      default: !1
    },
    // When set, displays these items and summary totals instead of the live
    // shared cart — used by Checkout.vue to show a restored (?orderid=)
    // order's actual charged amounts without touching the cart singleton
    // other mounted components (CartCount.vue, SideCart.vue) also read from.
    // Shape: { items, subtotal, discount, shipping, tax, total, item_count,
    // ca_redemption_value, me_bottle_deposit, shipping_method_name }.
    overrideCart: {
      type: Object,
      default: null
    }
  },
  setup(m) {
    const n = m;
    Ce(n.shippingExempt ? "event" : n.isOffering ? "offering" : "cart");
    const d = v(() => n.checkoutUrl || we()), { isValidUser: U } = Ue(), { config: h } = Ve(), {
      cart: p,
      loadCart: A,
      isLoadingCart: x,
      updateQuantity: k,
      isUpdatingQuantityInCart: b,
      isUpdatingCart: g,
      isAddingToCart: se,
      maxQuantityWarning: B,
      selectedShippingMethod: oe,
      fetchShippingOptions: ae
    } = Be(), { selectedAddress: D, data: M } = Oe(), { wish: ie, isSavingWish: ne, fetchWish: re, updateWishlistQuantity: le } = $e(), de = Se("container");
    function ue(i, e) {
      k(i, e);
    }
    function fe(i) {
      B.value = {
        sku: i.sku,
        name: i.name,
        max: i.max_purchase_quantity
      };
    }
    function ve(i, e) {
      le(i, e);
    }
    function E(i) {
      window.location = i;
    }
    const _ = v(() => n.overrideCart || p.value), Q = v(() => _.value.items.map((e) => Y(z({}, e), {
      image: e.image_small || e.image_medium || e.image_large || e.image
    }))), F = v(() => {
      if (!p.value.items.length)
        return null;
      const i = parseInt(h.value.cart_expires_length, 10);
      if (!i || i <= 0)
        return null;
      if (i < 3600) {
        const r = Math.round(i / 60);
        return `Your cart will expire after ${r} minute${r === 1 ? "" : "s"}.`;
      }
      const e = Math.round(i / 3600 * 10) / 10;
      return `Your cart will expire after ${e} hour${e === 1 ? "" : "s"}.`;
    }), O = v(() => {
      var i;
      return K() !== "offering" ? [] : Object.values((i = ie.value) != null ? i : {});
    }), L = v(() => O.value.reduce((i, e) => i + (parseFloat(e.price) || 0) * (e.quantity || 0), 0)), P = v(() => O.value.reduce((i, e) => i + (e.quantity || 0), 0)), me = v(() => `${P.value} item${P.value === 1 ? "" : "s"} you have wish requested`), I = v(() => h.value.enable_co_retail_delivery_fee && D.value && D.value.state === "CO" && p.value.co_retail_delivery_fee || 0), R = v(() => {
      var e;
      if (!parseInt((e = p.value.config) == null ? void 0 : e.insurance))
        return 0;
      const i = (parseFloat(h.value.cart_insurance) || 1) / 100;
      return Math.round(
        i * ((p.value.subtotal || 0) - (p.value.discount || 0)) * 100
      ) / 100;
    }), ce = v(() => (p.value.tax || 0) - I.value), V = v(() => {
      var i;
      return n.overrideCart ? n.overrideCart.shipping_method_name || null : ((i = oe.value) == null ? void 0 : i.name) || null;
    }), W = v(() => n.overrideCart ? n.overrideCart.shipping || 0 : (p.value.shipping || 0) - R.value), ye = v(() => n.overrideCart ? n.overrideCart.tax || 0 : ce.value);
    return be(
      [U, D, M],
      () => G(null, null, function* () {
        !U.value || !M.value || M.value.length === 0 || (yield ae());
      }),
      { immediate: !0 }
    ), xe(() => {
      const i = new URLSearchParams(window.location.search), e = i.get("addToCart"), r = i.get("quantity");
      i.get("checkout"), e && addProductToCart({ sku: e, quantity: r }), qe(de.value, n.inheritStyle), A(), K() === "offering" && re();
    }), (i, e) => (t(), s("div", Qe, [
      o("div", Ie, [
        o("div", Re, [
          q(i.$slots, "header", {}, () => [
            e[2] || (e[2] = o("h2", null, "Cart", -1))
          ], !0)
        ]),
        a(B) ? (t(), s("div", Ee, [
          e[3] || (e[3] = C(" Only up to ", -1)),
          o("strong", null, l(a(B).max), 1),
          C(" of " + l(a(B).name) + " can be in your cart. ", 1)
        ])) : u("", !0),
        a(x) ? (t(), s("div", Fe, [
          e[4] || (e[4] = C("Loading ", -1)),
          f(y)
        ])) : (t(), s("div", Le, [
          o("div", Pe, [
            F.value && !n.readOnly ? (t(), s("div", We, l(F.value), 1)) : u("", !0),
            o("div", je, [
              Q.value.length ? (t(!0), s(H, { key: 0 }, J(Q.value, (r) => (t(), s("div", {
                key: r.sku,
                class: "item"
              }, [
                a(S)(r.image) ? u("", !0) : (t(), s("div", Ne, [
                  o("img", {
                    src: r.image,
                    alt: r.name,
                    loading: "lazy",
                    decoding: "async"
                  }, null, 8, ze)
                ])),
                o("div", Ye, [
                  o("div", null, [
                    o("strong", null, l(r.name), 1),
                    o("em", null, l(r.subtitle), 1),
                    a(S)(r.bottle_size) ? u("", !0) : (t(), s("span", Ge, l(r.bottle_size), 1))
                  ])
                ]),
                o("div", He, [
                  !n.isOffering && !n.readOnly ? (t(), $(Z, {
                    key: 0,
                    modelValue: r.quantity,
                    "onUpdate:modelValue": (w) => r.quantity = w,
                    onChange: (w) => ue(r.sku, w),
                    onMaxExceeded: (w) => fe(r),
                    disabled: a(b)[r.sku],
                    max: r.max_purchase_quantity,
                    "hide-exceeded-message": ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "onMaxExceeded", "disabled", "max"])) : (t(), s("span", Je, l(r.quantity), 1))
                ]),
                o("div", Ke, [
                  a(b)[r.sku] ? (t(), s("div", Xe, [
                    f(y)
                  ])) : (t(), s("div", Ze, l(a(c)(r.price * r.quantity)), 1))
                ])
              ]))), 128)) : (t(), s("div", et, [
                e[6] || (e[6] = o("p", null, "You don't have any items in your cart.", -1)),
                f(X, {
                  onClick: e[0] || (e[0] = (r) => E(n.shopUrl))
                }, {
                  default: T(() => e[5] || (e[5] = [
                    C("Start Shopping", -1)
                  ])),
                  _: 1,
                  __: [5]
                })
              ])),
              f(Te, { name: "offset-cart-adding-item" }, {
                default: T(() => [
                  a(se) ? (t(), s("div", tt, [
                    e[7] || (e[7] = o("div", { class: "offset-cart-adding-item-image" }, null, -1)),
                    e[8] || (e[8] = o("div", { class: "offset-cart-adding-item-name" }, "Adding item…", -1)),
                    f(y)
                  ])) : u("", !0)
                ]),
                _: 1
              })
            ])
          ]),
          O.value.length ? (t(), $(Me, {
            key: 0,
            class: "offset-wish-summary",
            label: me.value
          }, {
            closed: T(() => e[9] || (e[9] = [])),
            opened: T(() => [
              e[11] || (e[11] = o("p", { class: "offset-wish-summary-note" }, "These items are not guaranteed.", -1)),
              o("div", st, [
                (t(!0), s(H, null, J(O.value, (r) => (t(), s("div", {
                  key: r.sku,
                  class: "item"
                }, [
                  o("div", ot, [
                    o("strong", null, l(r.description), 1)
                  ]),
                  o("div", at, [
                    n.isOffering ? (t(), s("span", it, l(r.quantity), 1)) : (t(), $(Z, {
                      key: 0,
                      modelValue: r.quantity,
                      "onUpdate:modelValue": (w) => r.quantity = w,
                      onChange: (w) => ve(r.sku, w),
                      disabled: a(ne)[r.sku]
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                  ]),
                  o("div", nt, l(a(c)((parseFloat(r.price) || 0) * r.quantity)), 1)
                ]))), 128))
              ]),
              o("div", rt, [
                e[10] || (e[10] = o("div", null, "Subtotal", -1)),
                o("div", null, "Up to " + l(L.value > 0 ? a(c)(L.value) : "TBD"), 1)
              ]),
              e[12] || (e[12] = o("div", { class: "offset-order-summary-shipping" }, [
                o("div", null, "Delivery"),
                o("div", null, "TBD")
              ], -1)),
              e[13] || (e[13] = o("div", { class: "offset-order-summary-tax" }, [
                o("div", null, "Sales Tax"),
                o("div", null, "TBD")
              ], -1)),
              e[14] || (e[14] = o("div", { class: "offset-checkout-info offset-wish-summary-message" }, [
                C(" At the end of our offering period, we will do our best to fulfill some or all of your Wish Requests. At that time, "),
                o("strong", null, "the incremental amount will be charged to the payment method on file"),
                C(" and an email receipt will follow including adjusted subtotal, along with any applicable tax and shipping. ")
              ], -1))
            ]),
            _: 1
          }, 8, ["label"])) : u("", !0),
          q(i.$slots, "editcart", {}, void 0, !0),
          Q.value.length ? (t(), s("div", lt, [
            e[25] || (e[25] = o("h2", null, "Order Summary", -1)),
            a(h).enable_promo && n.showPromoCode && !n.readOnly ? (t(), $(Ae, { key: 0 })) : u("", !0),
            !n.overrideCart && !a(S)(a(h).minimum_checkout_quantity) && parseInt(a(h).minimum_checkout_quantity, 10) > a(p).bottle_count ? (t(), s("div", dt, [
              e[15] || (e[15] = C(" There is a ", -1)),
              o("strong", null, l(a(h).minimum_checkout_quantity), 1),
              e[16] || (e[16] = C(" bottle minimum for this order. ", -1))
            ])) : u("", !0),
            o("div", ut, [
              o("div", null, "Subtotal (" + l(_.value.item_count) + ")", 1),
              a(g) ? (t(), s("div", ft, [
                f(y)
              ])) : (t(), s("div", vt, l(a(c)(_.value.subtotal)), 1))
            ]),
            a(S)(_.value.discount) ? u("", !0) : (t(), s("div", mt, [
              e[17] || (e[17] = o("div", null, "Discount", -1)),
              a(g) ? (t(), s("div", ct, [
                f(y)
              ])) : (t(), s("div", yt, l(a(c)(_.value.discount * -1)), 1))
            ])),
            a(S)(_.value.shipping) ? V.value ? (t(), s("div", Ct, [
              o("div", null, "Shipping (" + l(V.value) + ")", 1),
              a(g) ? (t(), s("div", wt, [
                f(y)
              ])) : (t(), s("div", St, l(a(c)(W.value)), 1))
            ])) : u("", !0) : (t(), s("div", pt, [
              V.value ? (t(), s("div", _t, " Shipping (" + l(V.value) + ") ", 1)) : (t(), s("div", ht, "Shipping")),
              a(g) ? (t(), s("div", gt, [
                f(y)
              ])) : (t(), s("div", kt, l(a(c)(W.value)), 1))
            ])),
            R.value > 0 && !n.overrideCart ? (t(), s("div", bt, [
              e[18] || (e[18] = o("div", null, "Shipping Insurance", -1)),
              a(g) ? (t(), s("div", xt, [
                f(y)
              ])) : (t(), s("div", qt, l(a(c)(R.value)), 1))
            ])) : u("", !0),
            a(S)(_.value.ca_redemption_value) ? u("", !0) : (t(), s("div", Tt, [
              e[19] || (e[19] = o("div", null, "California Redemption Value (CRV)", -1)),
              a(g) ? (t(), s("div", Ut, [
                f(y)
              ])) : (t(), s("div", Bt, l(a(c)(_.value.ca_redemption_value)), 1))
            ])),
            a(S)(_.value.me_bottle_deposit) ? u("", !0) : (t(), s("div", Ot, [
              e[20] || (e[20] = o("div", null, "Maine Bottle Deposit (MBD)", -1)),
              a(g) ? (t(), s("div", Vt, [
                f(y)
              ])) : (t(), s("div", $t, l(a(c)(_.value.me_bottle_deposit)), 1))
            ])),
            I.value > 0 && !n.overrideCart ? (t(), s("div", At, [
              e[21] || (e[21] = o("div", null, "Colorado Retail Delivery Fee", -1)),
              a(g) ? (t(), s("div", Dt, [
                f(y)
              ])) : (t(), s("div", Mt, l(a(c)(I.value)), 1))
            ])) : u("", !0),
            o("div", Qt, [
              e[22] || (e[22] = o("div", null, "Tax", -1)),
              a(g) ? (t(), s("div", It, [
                f(y)
              ])) : (t(), s("div", Rt, l(a(c)(ye.value)), 1))
            ]),
            o("div", Et, [
              e[23] || (e[23] = o("div", null, "Total", -1)),
              a(g) ? (t(), s("div", Ft, [
                f(y)
              ])) : (t(), s("div", Lt, l(a(c)(_.value.total)), 1))
            ]),
            n.hideActions ? u("", !0) : (t(), s("div", Pt, [
              q(i.$slots, "actions", {}, () => [
                f(X, {
                  onClick: e[1] || (e[1] = (r) => E(d.value))
                }, {
                  default: T(() => e[24] || (e[24] = [
                    C("Proceed to Checkout", -1)
                  ])),
                  _: 1,
                  __: [24]
                })
              ], !0)
            ]))
          ])) : u("", !0),
          q(i.$slots, "below-summary", {}, void 0, !0),
          q(i.$slots, "footer-actions", {}, void 0, !0)
        ]))
      ])
    ], 512));
  }
}, ns = /* @__PURE__ */ De(Wt, [["__scopeId", "data-v-d6212898"]]);
export {
  ns as C
};
